import type { ComponentType } from "react";
import { Button, Menu, Tooltip } from "@knowtex-ai/components";
import { MoreHoriz } from "iconoir-react";

export interface RowAction {
  key: string;
  label: string;
  icon?: ComponentType<{ className?: string }>;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
}

interface RowActionsProps {
  actions: RowAction[];
  /** Names the menu for assistive tech, e.g. "Actions for run 4c3b2a10" */
  label: string;
}

/** A lone action with an icon shows as an icon button; several share a dropdown menu. */
export default function RowActions({ actions, label }: RowActionsProps) {
  if (actions.length === 0) return null;
  const [only] = actions;
  if (actions.length === 1 && only.icon) {
    return (
      <Tooltip label={only.label}>
        <Button
          variant="secondary"
          size="small"
          icon={only.icon}
          aria-label={only.label}
          disabled={only.disabled}
          onClick={only.onClick}
        />
      </Tooltip>
    );
  }
  return (
    <Menu
      variant="text"
      size="small"
      icon={MoreHoriz}
      showArrow={false}
      aria-label={label}
      items={actions.map((action) => ({
        key: action.key,
        label: action.label,
        icon: action.icon,
        disabled: action.disabled,
        variant: action.danger ? "danger" : "default",
        onClick: action.onClick,
      }))}
    />
  );
}
